export const GET_ADDRESS_SUCCESS = 'GET_ADDRESS_SUCCESS';
export const GET_ADDRESS_REQUEST = 'GET_ADDRESS_REQUEST';
export const GET_ADDRESS_FAILURE = 'GET_ADDRESS_FAILURE';
export const getAddressSuccess = (payload) => ({
    type: GET_ADDRESS_SUCCESS,
    payload,
});
export const getAddressRequest = () => ({
    type: GET_ADDRESS_REQUEST,
});
export const getAddressFailure = (payload) => ({
    type: GET_ADDRESS_FAILURE,
    payload,
});
